// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"3bba0649","285":"3bba0649","387":"1bad3e34","589":"a00f99fb","759":"74a40998"}[chunkId] + ".chunk.css";
};